var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaStationSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b{fill:#353841;}.c{fill:#fff;}.d{stroke:none;}.e{fill:none;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-201 -633)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 53,
    height: 53,
    rx: 10,
    transform: "translate(202.5 634.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(214 641)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-109.3-54.847A15.253,15.253,0,0,0-124.648-70,15.253,15.253,0,0,0-140-54.847c0,9.849,15.352,25,15.352,25S-109.3-45-109.3-54.847",
    transform: "translate(140 70)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.638 8.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M216.6,243.983c.126-.156.235-.3.35-.436.726-.859,1.452-1.715,2.172-2.577a.505.505,0,0,1,.492-.2,29.77,29.77,0,0,1,6.775,1.559,5.82,5.82,0,0,1,.565.256,1.415,1.415,0,0,1,.171.121,6.152,6.152,0,0,1-3.264,2.772,4,4,0,0,1-.176-.428.951.951,0,0,0-.608-.7,15.387,15.387,0,0,0-1.621-.415,5.508,5.508,0,0,0-.9-.055c-.381-.012-.421.02-.5.4q-.263,1.281-.519,2.563-.926,4.568-1.852,9.136-.5,2.448-1.006,4.895a.524.524,0,0,1-.116.242c-.1-.461-.2-.922-.291-1.383q-1.595-7.774-3.184-15.55c-.046-.225-.125-.331-.368-.3-.692.087-1.392.126-2.075.252a1.435,1.435,0,0,0-1.214,1.1,1.675,1.675,0,0,1-.1.23,6.284,6.284,0,0,1-3.29-2.755c.186-.069.327-.125.471-.174,1-.344,1.995-.741,3.018-1.015,1.048-.281,2.127-.447,3.195-.649.322-.061.653-.069.978-.115a.366.366,0,0,1,.373.156c.737.9,1.484,1.8,2.227,2.7C216.371,243.716,216.454,243.814,216.6,243.983Z",
    transform: "translate(-204.891 -238.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M184.912,192.247l-.842-1.863a35.93,35.93,0,0,1,23.429,0c-.156.319-.308.626-.461.934s-.3.6-.471.934c-.455-.134-.914-.252-1.361-.4a27.738,27.738,0,0,0-6.42-1.364,34.166,34.166,0,0,0-6.085.008,30.668,30.668,0,0,0-7.041,1.551C185.424,192.121,185.179,192.174,184.912,192.247Z",
    transform: "translate(-184.07 -188.44)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaStationSelected);
export default __webpack_public_path__ + "static/media/tesla_station_selected.588881bf2acf9a67351a932f069c8bb4.svg";
export { ForwardRef as ReactComponent };